import React from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useAuth } from "../Context/AuthContext";
import {AiOutlineMenu} from 'react-icons/ai'

export const Navbar = () => {
  let navigate = useNavigate();
  const { logout } = useAuth();
  const handleLogout = async () => {
    // localStorage.removeItem('token');
    try {
      await logout();
      navigate("/");
    } catch {}
  };
  return (
    <section className="admin-navbar">

    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <span class="navbar-brand" >
          <img src="Images/Logo.png" alt="" className="brand-logo" />
        </span>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon" ><AiOutlineMenu style={{fontSize:'26px'}}/></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0 btngrp">
          <li class="nav-item">
              <button
               data-bs-toggle="modal" data-bs-target="#promocodeModal"
              >
                Promo Code
              </button>
            </li>
            <li class="nav-item">
              <button
                data-bs-toggle="modal"
                data-bs-target="#orderModal"
              >
                Orders
              </button>
            </li>
            <li class="nav-item">
              <button data-bs-toggle="modal" data-bs-target="#variantModal">
                Add Varaiant
              </button>
            </li>
            <li class="nav-item">
              <button
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Add Product
              </button>
            </li>
            <li class="nav-item">
              <button onClick={handleLogout}>Log Out</button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </section>

    
  );
};
